module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-body-wrap",
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "c-main",
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [_c('complete'), _vm._v(" "), _c('promotions')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97fd7cc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppComplete.vue
// module id = 67
// module chunks = 0